var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(false)?[_c('LoadCssComponent',{attrs:{"estilos":_vm.configuracion.css_front}})]:_vm._e(),_c('HeaderComponent'),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('main',{attrs:{"id":"main"}},[_c('router-view')],1)]),_c('FooterComponent')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }